import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';

const stats = [
  { num: '500+', label: '施工実績', icon: 'ri-home-smile-line' },
  { num: '99%', label: '顧客満足度', icon: 'ri-star-line' },
  { num: '10年', label: '地域密着の実績', icon: 'ri-map-pin-line' },
  { num: '0円', label: '追加費用', icon: 'ri-price-tag-3-line' },
];

const areas = ['つくばみらい市', '守谷市', '取手市', '龍ヶ崎市', '牛久市', '利根町', 'つくば市', '阿見町', '常総市', '我孫子市'];

export default function AboutSection() {
  const { ref, isVisible } = useIntersectionObserver(0.1);

  return (
    <section id="about" className="py-20 md:py-28 bg-navy-50 overflow-hidden">
      <div
        ref={ref}
        className="max-w-7xl mx-auto px-4 md:px-8"
        style={{
          opacity: isVisible ? 1 : 0,
          transition: 'opacity 0.7s ease',
        }}
      >
        <div className="text-center mb-14">
          <span className="inline-block text-accent font-display font-bold text-xs tracking-widest uppercase mb-3">
            About Us
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-navy leading-tight mb-3">
            会社概要・信頼の証
          </h2>
          <div className="w-16 h-1 bg-accent mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-start mb-12">
          <div
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateX(0)' : 'translateX(-20px)',
              transition: 'opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s',
            }}
          >
            <div className="relative rounded-2xl overflow-hidden mb-6" style={{ height: '320px' }}>
              <img
                src="https://public.readdy.ai/ai/img_res/6109d49adc492a923d58ba8487ee334d.jpg"
                alt="株式会社アイリープランニング 施工スタッフ"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/50 to-transparent"></div>
              <div className="absolute bottom-4 left-4 text-white">
                <p className="font-bold text-lg">株式会社アイリープランニング</p>
                <p className="text-sm text-white/80">トイレ専門店48 "forty-eight" 運営</p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-white rounded-xl p-4 flex items-center gap-3 border border-gray-100">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-navy/5 flex-shrink-0">
                    <i className={`${stat.icon} text-navy text-lg`}></i>
                  </div>
                  <div>
                    <p className="font-display font-black text-accent text-xl leading-tight">{stat.num}</p>
                    <p className="text-gray-500 text-xs">{stat.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateX(0)' : 'translateX(20px)',
              transition: 'opacity 0.7s ease 0.2s, transform 0.7s ease 0.2s',
            }}
          >
            <div className="bg-white rounded-2xl p-7 md:p-8 border border-gray-100 mb-6">
              <h3 className="font-black text-navy text-xl mb-5">会社情報</h3>
              <table className="w-full text-sm">
                <tbody className="divide-y divide-gray-50">
                  {[
                    { label: '会社名', value: '株式会社アイリープランニング' },
                    { label: 'ブランド', value: 'トイレ専門店48 "forty-eight"' },
                    { label: '所在地', value: '茨城県つくばみらい市（詳細はお問い合わせください）' },
                    { label: '事業内容', value: 'トイレリフォーム専門（施工・販売）' },
                    { label: '対応時間', value: '9:00〜18:00（定休日：日曜日・木曜日）' },
                    { label: '施工保証', value: '工事完了後1年間の無償保証付き' },
                  ].map((row) => (
                    <tr key={row.label}>
                      <td className="py-3 pr-4 text-gray-400 font-medium w-24 flex-shrink-0 whitespace-nowrap">{row.label}</td>
                      <td className="py-3 text-gray-700">{row.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="bg-navy rounded-2xl p-7 md:p-8 text-white">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-map-pin-2-fill text-accent text-lg"></i>
                </span>
                <h3 className="font-black text-xl">地域限定だから、速い。</h3>
              </div>
              <p className="text-white/70 text-sm leading-relaxed mb-5">
                対応エリアをあえて絞ることで、迅速な対応と高い施工品質を両立しています。
                地元に根ざした専門店だからこそ、48時間以内着工が実現できます。
              </p>
              <div className="flex flex-wrap gap-2">
                {areas.map((area) => (
                  <span
                    key={area}
                    className="bg-white/10 text-white text-xs px-3 py-1.5 rounded-full border border-white/20"
                  >
                    {area}
                  </span>
                ))}
              </div>
              <p className="text-white/50 text-xs mt-4">
                ※対応可否についてはLINEにてお気軽にご確認ください。
              </p>
            </div>
          </div>
        </div>

        <div
          className="grid grid-cols-1 md:grid-cols-3 gap-4"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.7s ease 0.4s, transform 0.7s ease 0.4s',
          }}
        >
          {[
            {
              icon: 'ri-shield-check-line',
              title: '安心の品質保証',
              desc: '施工後1年間の無償保証付き。万一の不具合にも迅速に対応します。',
            },
            {
              icon: 'ri-team-line',
              title: '多能工による一貫施工',
              desc: '一人のプロが全工程を担当。複数業者の調整ストレスがありません。',
            },
            {
              icon: 'ri-secure-payment-line',
              title: 'コミコミ明朗会計',
              desc: '見積もり額がそのまま最終金額。後から追加費用が発生しません。',
            },
          ].map((item) => (
            <div key={item.title} className="bg-white rounded-xl p-5 border border-gray-100 flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent/10 flex-shrink-0">
                <i className={`${item.icon} text-accent text-lg`}></i>
              </div>
              <div>
                <p className="font-bold text-navy text-sm mb-1">{item.title}</p>
                <p className="text-gray-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div
          className="mt-8 bg-white rounded-2xl p-7 md:p-10 border border-gray-100"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.7s ease 0.55s, transform 0.7s ease 0.55s',
          }}
        >
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent/10 flex-shrink-0">
              <i className="ri-heart-line text-accent text-lg"></i>
            </div>
            <h3 className="font-black text-navy text-xl">私たちの思い</h3>
          </div>
          <p className="text-lg md:text-xl font-black text-navy mb-4 leading-tight">
            『選ばれる理由をつくり、期待を超えるサービスを』
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            私たちは、単に商品を提供するだけでなく、お客様との信頼関係を築くことを大切にしています。すべてのひとときが、心温まる体験となるよう、スタッフ一同努力を重ねてまいります。お客様の声に耳を傾け、日々成長するお店でありたいと考えております。
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            また、暮らしの伴走者として工事後も外壁診断や設備点検で、住まいを一生守ります。
          </p>
        </div>
      </div>
    </section>
  );
}
